import ReactConfetti from 'react-confetti';
import { cn } from 'lib/utils';

interface ConfettiProps {
  show: boolean;
  className?: string;
}

export default function Confetti({ show, className }: ConfettiProps) {
  if (!show) return null;

  return (
    <div
      aria-hidden='true'
      className={cn(
        'absolute z-[9999] inset-0 flex justify-center overflow-hidden pointer-events-none select-none',
        className
      )}
    >
      <ReactConfetti data-testid='confetti-canvas' />
    </div>
  );
}
